import React from "react";

import * as UI from "./ui";
export const PAGE_SIZE_OPTIONS = [10, 25, 50];

const PaginationControl = ({ donorGuestEntries, page, setPage, pageSize, setPageSize }) => {
  const totalCount = donorGuestEntries?.totalCount ?? 0;
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  if (totalCount <= PAGE_SIZE_OPTIONS[0]) {
    return null;
  }

  const handlePrevPage = () => {
    if (page <= 1) {
      return;
    }

    setPage(page - 1);
  };

  const handleNextPage = () => {
    if (page >= totalPages) {
      return;
    }

    setPage(page + 1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(Number(event.target.value));
    setPage(1);
  };

  return (
    <UI.PaginationControls>
      <UI.PageSizeControls>
        <UI.PageSizeLabel>
          Per page
          <UI.PageSizeSelect
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            {PAGE_SIZE_OPTIONS.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </UI.PageSizeSelect>
        </UI.PageSizeLabel>
      </UI.PageSizeControls>
      <UI.PageIndicator>Page {page} of {totalPages}</UI.PageIndicator>
      <UI.PageButtons>
        <UI.PageButton
          type="button"
          onClick={handlePrevPage}
          disabled={page <= 1}
        >
          Prev
        </UI.PageButton>
        <UI.PageButton
          type="button"
          onClick={handleNextPage}
          disabled={page >= totalPages}
        >
          Next
        </UI.PageButton>
      </UI.PageButtons>
    </UI.PaginationControls>
  );
};

export default PaginationControl;